import { useAppDispatch, useAppSelector } from "@/config/store";
import { AuthenticationState, logout } from "@/shared/reducers/authentication";
import { SocketContext } from "context/socket";
import { useContext, useEffect, useLayoutEffect } from "react";

export const Logout = () => {
  const dispatch = useAppDispatch();
  const socket = useContext(SocketContext);
  const { logoutSuccess } = useAppSelector<AuthenticationState>(
    (state) => state.authentication
  );

  useLayoutEffect(() => {
    dispatch(logout());
  });

  useEffect(() => {
    if (logoutSuccess) {
      socket?.disconnect();
    }
  }, [logoutSuccess]);

  return (
    <div className="p-4">
      <h2 className="font-heading text-heading font-semibold text-[var(--color-mockup-text)]">
        Logged out successfully!
      </h2>
    </div>
  );
};

export default Logout;
